/* @flow */
import React, { Element as ReactElement } from 'react';
import Portal from 'react-portal';
import classnames from 'classnames/bind';
import styled from 'styled-components';
import {CloseIcon} from '../icons/Icons';
import s from './Modal.styl';
const cx = classnames.bind(s);

const ESCAPE = 27;

const StyledModalTitle = styled.div`
  position: relative;
  line-height: 50px;
  background: ${({ theme }) => theme.ThemeColors.LIGHT_GRAY_SURFACE.hex};
  border-bottom: 1px solid ${({ theme }) => theme.ThemeColors.BORDER.hex};
  color: ${({ theme }) => theme.ThemeColors.TEXT.hex};
  border-radius: 6px 6px 0px 0px;
  font-size: 1.34rem;
  letter-spacing: 1px;
  user-select: none;
  text-align: center;
`;

const StyledModalInnerContainer = styled.div`
  position: absolute;
  margin-bottom: 150px;
  top: 200px;
  left: 50%;
  transform: translateX(-50%);
  min-width: 51.67rem;
  background-color: ${({ theme }) => theme.ThemeColors.SURFACE.hex};
  border: 1px solid ${({ theme }) => theme.ThemeColors.BORDER.hex};
  border-radius: 6px;
  box-shadow: 0px 3px 54px 14px rgba(0, 0, 0, 0.14);
  color: ${({ theme }) => theme.ThemeColors.TEXT.hex};
`;

/**
 * Modal is essentially a customized version of react portal.
 *
 * Children mmust be passed to the modal, otherwise it will have nothing to
 * render other than the overlay.
 *
 * NOTE: We pass a prop called isOpen, while the modal supports the isOpened
 * param. That is just poor english.
 * UPDATE: I think the latest version may have corrected this.
 */

type ModalProps = {
  theme?: string,
  style?: Object,
  isOpen?: boolean,
  className?: string,
  children?: ReactElement<any>,
  onToggleModal: Function,
  outerClassName?: string,
};

export class Modal extends React.Component {
  props: ModalProps;

  closeOnEscape = (e: KeyboardEvent) => {
    if (e.which !== ESCAPE) return;
    e.stopPropagation();
    this.props.onToggleModal();
  };

  /**
   * NOTE: tabIndex is necessary to capture keyboard events on a div.
   */
  render() {
    const { children, isOpen, onToggleModal, className, theme, style, outerClassName, ...props } = this.props;
    return (
      <Portal isOpened={isOpen} {...props}>
        <div
          tabIndex={0}
          onKeyUp={this.closeOnEscape}
          className={cx(s.outerModal, theme, outerClassName)}
          onClick={onToggleModal}>
          <StyledModalInnerContainer
            style={style}
            onClick={e => e.stopPropagation()} className={cx(s.innerModal, className)}
          >
            {children}
          </StyledModalInnerContainer>
        </div>
      </Portal>
    );
  }
}

type ModalTitleProps = {
  onToggleModal?: Function,
  children?: any,
  className?: string,
};
export const ModalTitle = (props: ModalTitleProps) => (
  <StyledModalTitle {...props} className={cx(s.ModalTitle, props.className)}>
    {props.children}
    {props.onToggleModal && (
      <i className={cx('fa fa-times', s.closeButton)} onClick={props.onToggleModal}></i>
    )}
  </StyledModalTitle>
);


type NuModalTitleProps = {
  onToggleModal?: Function,
  children?: any,
  className?: string,
};
export const NuModalTitle = (props: NuModalTitleProps) => (
  <div {...props} className={cx(s.NuModalTitle, props.className)}>
    {props.children}
    {props.onToggleModal && (
      <CloseIcon className={cx('closeButton')} onClick={props.onToggleModal}></CloseIcon>
    )}
  </div>
);




// WEBPACK FOOTER //
// ./web_modules/trustar/components/Modal.js